<template>
  <router-view />
</template>

<script>
import useDocumentFile from '../hooks/useDocumentFile'

const {
  store: documentFileStore,
  setTotalPages,
  setFile,
  setInitialValue
} = useDocumentFile()

export default {
  name: 'DocumentMain',
  provide: {
    documentFileStore,
    setTotalPages,
    setFile,
    setInitialValue
  }
}
</script>
